export default __webpack_public_path__ + "static/media/english-to-portuguese-mobile-3.fa745326.png";